import React, { FC } from 'react';

import ProgressRing from '@adsk/alloy-react-progress-ring';

import FlexCentered from '../../components/FlexCentered';

const ProjectsLoader: FC = () => (
  <FlexCentered width="100%">
    <ProgressRing
      data-testid="ProjectsLoader"
      size={ProgressRing.SIZES.LARGE}
    />
  </FlexCentered>
);

export default ProjectsLoader;
